import { Badge } from '@chakra-ui/react'
import type { IDonationType } from '../model/donor-detail.types'

const defaultStyle = { bg: 'badge.gray.20', color: 'badge.gray.100' }

const styles: Record<IDonationType, { bg: string; color: string }> = {
  WHOLE_BLOOD: { bg: 'badge.red.20', color: 'badge.red.100' },
  PLASMAPHERESIS: { bg: 'badge.blue.20', color: 'badge.blue.100' },
  PLATELETPHERESIS: { bg: 'badge.teal.20', color: 'badge.teal.100' },
}

interface Props {
  type: IDonationType
  label: string
}

export function DonationTypeBadge({ type, label }: Props) {
  const badgeStyle = (type && styles[type]) || defaultStyle

  return (
    <Badge
      px={2}
      py={0.5}
      borderRadius="md"
      fontSize="xs"
      fontWeight="medium"
      w={'fit-content'}
      {...badgeStyle}
    >
      {label}
    </Badge>
  )
}
